import React from 'react';

export interface StatusIconProps {
  className?: string;
  size?: number;
}

export const SendingIcon: React.FC<StatusIconProps> = ({ className = 'h-3 w-3', size = 12 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    width={size}
    height={size}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
  </svg>
);

export const SentIcon: React.FC<StatusIconProps> = ({ className = 'h-3 w-3', size = 12 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    width={size}
    height={size}
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const DeliveredIcon: React.FC<StatusIconProps> = ({ className = 'h-3 w-3', size = 12 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    width={size}
    height={size}
  >
    <path d="M18 6 7 17l-5-5" />
    <path d="m22 10-7.5 7.5L13 16" />
  </svg>
);

export const ReadIcon: React.FC<StatusIconProps> = ({ className = 'h-3 w-3', size = 12 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    width={size}
    height={size}
  >
    <path d="M18 6 7 17l-5-5" />
    <path d="m22 10-7.5 7.5L13 16" />
  </svg>
);

export const ErrorIcon: React.FC<StatusIconProps> = ({ className = 'h-3 w-3', size = 12 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    width={size}
    height={size}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="m15 9-6 6" />
    <path d="m9 9 6 6" />
  </svg>
);